import { CssType, ThemeType } from '../../../../../theming/jssTypes';
import { createUseStyles } from 'react-jss';
const useStyles = createUseStyles(
  (theme: ThemeType): CssType => ({
    addCNModal: {
      display: 'flex',
      '& label': {
        display: 'flex',
        alignItems: 'center',
        border: `${theme.border.width.sm} solid ${theme.color.semantic.border.primary}`,
        padding: `${theme.spacing[1]} ${theme.spacing[3]}`,
        height: '36px',
        borderRadius: `${theme.radius.sm} ${theme.radius.none} ${theme.radius.none} ${theme.radius.sm}`,
      },
      '& input': {
        width: '230px',
        borderRadius: `${theme.radius.none} ${theme.radius.sm} ${theme.radius.sm} ${theme.radius.none}`,
      },
      '& button': {
        marginLeft: theme.spacing[2],
        float: 'right',
      },
    },
    tableContainer: {
      flex: '1 1 0',
      overflow: 'auto',
      height: 300,
      marginTop: theme.spacing[4],
      boxShadow: theme.shadow.md,
      '& .ant-table-tbody > tr > td, .ant-table-thead > tr > th': {
        padding: theme.spacing[2],
      },
      '& button': {
        float: 'right',
      },
    },
    table: {
      marginLeft: theme.spacing[0],
    },
    selectStyle: {
      width: '200px',
    },
    label: {
      marginLeft: theme.spacing[1],
    },
    selectQcChecked: {
      '& .ant-select-selection--single': {
        border: `${theme.border.width.sm} solid ${theme.color.semantic.accent.green.strong}`,
        background: theme.color.semantic.accent.green.subtle,
      },
      minWidth: '120px',
    },
    selectQcNotChecked: {
      '& .ant-select-selection--single': {
        border: `${theme.border.width.sm} solid ${theme.color.semantic.accent.orange.strong}`,
        background: theme.color.semantic.accent.orange.subtle,
      },
      minWidth: '120px',
    },
    qcChecked: {
      background: theme.color.semantic.accent.green.subtle,
      '&:hover': {
        background: `${theme.color.semantic.accent.green.subtle} !important`,
      },
      '&.ant-select-dropdown-menu-item-selected': {
        background: `${theme.color.semantic.accent.green.subtle} !important`,
      },
      '&.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled)':
        {
          background: `${theme.color.semantic.accent.green.subtle} !important`,
        },
    },
    qcNotChecked: {
      background: theme.color.semantic.accent.orange.subtle,
      '&:hover': {
        background: `${theme.color.semantic.accent.orange.subtle} !important`,
      },
      '&.ant-select-dropdown-menu-item-selected': {
        background: `${theme.color.semantic.accent.orange.subtle} !important`,
      },
      '&.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled)':
        {
          background: `${theme.color.semantic.accent.orange.subtle} !important`,
        },
    },
    qcStatus: {
      minWidth: '80px',
    },
    disableRto: {
      color: theme.color.semantic.text.soft,
    },
    rtoReason: {
      minWidth: '130px',
    },
  }),
);
export default useStyles;
